import { css } from '@emotion/css';

export const mediaContainerStyles = css`
  width: 26rem !important;
`;

export const carouselClassName = css`
  height: 7.6rem;
  & > div.keen-slider__slide:last-child > div.media-item {
    margin-inline-end: 1.2rem;
    width: 27.2rem !important;
  }
  & > div.keen-slider__slide:first-child > div.media-item {
    margin-inline-start: 1.2rem;
    width: 27.2rem !important;
  }
`;
